"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Severity = exports.Severity = {
  OK: -1,
  WARNING: 0,
  ERROR: 1
};